const e = "Cartões de selos", o = "Taxa de entrega", a = "Outras cobranças", n = "Cashback", r = "Métodos de pagamento", i = "Pagar", t = "Nível", s = "Pontos", d = "Cartão de Fidelização", c = "Recompensas", l = "Desconto", m = "Dica", p = "Total", u = "Subtotal", g = "Entregue", h = "Preparar", v = "Entrega", f = "Na sala", L = "Para levar", k = "Carregue mais", b = "Manter", y = "Nome", P = "Sobrenomes", C = "Email", T = "Aniversário", A = "Tags", O = "Gênero", x = "Linguagem", S = "Código postal", H = "ccc", V = "A domicílio", w = "Pegar", E = "Desconhecido", D = "Telefone", M = "Hoje", R = "Manhã", W = "Dia", z = "Hora", F = "Chamar", N = "Convidado", q = "Entrar ou cadastrar", I = "Uber", B = "Glovo", G = "Deliveroo", U = "Justeat", j = {
  "wallet.loading.errorTitle": "Ocorreu um erro",
  "wallet.loading.error": "Tenta descarregar novamente",
  "wallet.loading.android.success": "Guardado no Google Wallet",
  "wallet.loading.ios.success": "Guardado no Apple Wallet",
  "wallet.loading.ios": "A carregar no Apple Wallet",
  "wallet.loading.android": "A carregar no Google Wallet",
  stampCards: e,
  "stampCard.complete": "Parabéns! Você completou todos os ciclos disponíveis.",
  "stampCard.cycleEnd": "Você ganhou uma nova recompensa. Obrigado por nos visitar!",
  "stampCard.expired": "O cartão expirou",
  "stampCard.expirationLabel": "Validade:",
  "userOrders.empty": "O seu histórico de pedidos está vazio",
  "userOrders.info": "Selecione um pedido para ver os detalhes do recibo",
  deliveryFee: o,
  defaultFeeName: a,
  "kioskLanding.outOfOrder.title": "Fora de serviço",
  "kioskLanding.outOfOrder.subtitle": "Não são aceitos pedidos no momento. Consulte um garçom para iniciar um pedido.",
  "kioskLanding.language.title": "Selecione um idioma",
  "kioskLanding.service.title": "Onde você quer seu pedido?",
  "kioskLanding.service.takeaway": "Para viagem",
  "kioskLanding.service.dineIn": "Comer no local",
  "kioskLanding.service.otherLanguages": "Outros idiomas",
  "kioskLanding.inactive.title": "Deseja continuar o pedido?",
  "kioskLanding.inactive.prelude": "Será cancelado automaticamente",
  "kioskLanding.inactive.cancel": "Cancelar pedido",
  "kioskLanding.inactive.continue": "Continuar",
  "userGreetings.defaultUnAuthenticatedText": "Faça login",
  "userGreetings.defaultAuthenticatedText": "Bem vindo, *|customer_name|*",
  "viewOrder.cashbackSpent": "{{denomination}} gasto",
  "viewOrder.cashbackObtained": "{{denomination}} ganho",
  "orderRecord.anonOrderText": "Atualização manual",
  "myCashback.historyTitle": "Histórico de  {{denomination}}",
  "myCashback.denomination": "{{denomination}} actual",
  cashback: n,
  "loginPage.prelude": "Você deve estar logado para visualizar esta página",
  "loginPage.callToAction": "Clique aqui para logar",
  paymentMethods: r,
  "shopLanding.singleRestaurant.delivery.title": "Quando você quer seu pedido?",
  "shopLanding.fetchAction.confirmation.accept": "Aceitar",
  "shopLanding.fetchAction.confirmation.cancel": "Cancelar",
  "shopLanding.fetchAction.confirmation.title": "Tem certeza?",
  "shopLanding.fetchAction.confirmation.body": "Por favor confirme esta ação",
  "shopLanding.fetchAction.2xx.title": "Sucesso",
  "shopLanding.fetchAction.2xx": "{status} Sucesso",
  "shopLanding.fetchAction.3xx.title": "Redirecionar",
  "shopLanding.fetchAction.3xx": "{status} Redirecionar",
  "shopLanding.fetchAction.error.title": "Erro",
  "shopLanding.fetchAction.error": "{status} Erro",
  "shopLanding.loadingRestaurants": "Preparando restaurantes",
  "shopLanding.book.confirmation.bookingPolicy.label": "Dou o meu consentimento para o tratamento de dados pessoais",
  "shopLanding.book.error.text": "Algo deu errado. Tente novamente mais tarde.",
  "shopLanding.book.success.title": "Sua reserva foi concluída",
  "shopLanding.book.success.text": "Sua reserva foi concluída",
  "shopLanding.book.confirmation.submit": "Confirmar",
  "shopLanding.book.confirmation.marketing.label": "Concordo em receber promoções da marca em meu e-mail",
  "shopLanding.book.confirmation.form.observations.placeholder": "Observações",
  "shopLanding.book.confirmation.form.observations.label": "Observações",
  "shopLanding.book.confirmation.form.area.placeholder": "Sala 1",
  "shopLanding.book.confirmation.form.area.label": "Selecione a área",
  "shopLanding.book.confirmation.title": "Confirme sua reserva:",
  "shopLanding.book.listing.submit": "Continuar",
  "shopLanding.book.listing.title": "Reserve em:",
  "shopLanding.book.notMatch.text": "No momento, não podemos oferecer locais que correspondam às suas preferências.",
  "shopLanding.book.notMatch.title": "Não há locais disponíveis",
  "shopLanding.book.reservation.submit": "Encontre um restaurante",
  "shopLanding.book.reservation.title": "Faça sua reserva",
  "shopLanding.book.nOfPeople": "Nº de pessoas",
  "shopLanding.book": "Reservar",
  "magiclink.tryAgain": "Tente novamente",
  "magiclink.email.code.input": "Insira o código",
  "magiclink.email.code.try.again": "Começar de novo",
  "magiclink.email.code.continue": "Continuar",
  "magiclink.email.title": "Insira o código que enviamos para seu e-mail",
  "magiclink.email.code.error": "Código inválido",
  "magiclink.email.content": "Em poucos minutos você receberá em seu e-mail um link para acessar. Se você não conseguir encontrá-lo na sua caixa de entrada, verifique sua pasta de spam.",
  "payments.engine.7": "Pagar depois",
  "payments.engine.10": "Cartão, Apple pay ou Google Pay",
  "payments.redirect.verifying": "A processar o pagamento…",
  "payments.redirect.errorTitle": "Não foi possível concluir o pagamento.",
  "payments.redirect.error": "Ocorreu um erro ou o pagamento foi cancelado. Tente novamente.",
  "payments.method.5": "Dinheiro",
  "payments.method.4": "Bizum",
  "payments.method.3": "Apple pay",
  "payments.method.2": "Google pay",
  "payments.method.1": "Cartão de crédito",
  "shopLanding.legal.bookingPolicy": "Política de Reservas",
  "shopLanding.legal.cookiesPolicy": "Política de Cookies",
  "shopLanding.legal.privacyPolicy": "Política de Privacidade",
  "shopLanding.legal.termsAndConditions": "Termos e Condições de Compra",
  payLink: i,
  "loyaltyCard.disabled": "O cartão de fidelidade não está disponível no momento",
  tier: t,
  points: s,
  loyaltyCard: d,
  vouchers: c,
  "weekdays.short.monday": "Seg",
  "weekdays.short.tuesday": "Ter",
  "weekdays.short.wednesday": "Qua",
  "weekdays.short.thursday": "Qui",
  "weekdays.short.friday": "Sex",
  "weekdays.short.saturday": "Sab",
  "weekdays.short.sunday": "Dom",
  "voucher.expiredBurnBtnText": "Oferta não disponível",
  "voucher.burnBtnText": "Marcar cupom como usado",
  "voucher.terms.scheduleAllDays": "Todos os dias",
  "voucher.terms.schedule": "Agendar",
  "voucher.terms.usesTimeframe.43200": "usa a cada 12 horas",
  "voucher.terms.usesTimeframe.86400": "usos diários",
  "voucher.terms.usesTimeframe.604800": "usos semanais",
  "voucher.terms.usesTimeframe.2592000": "usos mensais",
  "voucher.terms.maximum": "Máximo:",
  "voucher.terms.usesTotal": "Usos totais",
  "voucher.terms.usesAndLimitations": "Usos e limitações",
  "terms.title": "Termos e Condições",
  "voucher.error.noMoreUses": "Sem usos restantes",
  "voucher.error.outOfSchedule": "Fora do tempo",
  "voucher.error.nextActivation": "Próxima ativação",
  "addToWallet.android": "Adicionar à Carteira Google",
  "addToWallet.apple": "Adicionar à Carteira Apple",
  "voucher.unlimited": "Ilimitado",
  "voucher.validFromTitle": "Válido de",
  "voucher.validUntilTitle": "Valido ate",
  "voucher.remainingUsesTitle": "Usos restantes",
  "voucher.pendingValidation": "Conta pendente de verificação",
  "voucher.verify": "Verificar",
  "ticket.placed": "Criada",
  "ticket.followOrderBtn": "Siga seu pedido",
  discount: l,
  tip: m,
  total: p,
  subtotal: u,
  "order.status.unconfirmed": "Não confirmado",
  "order.status.confirmed": "Confirmado",
  "order.status.ready": "Pronto",
  "order.status.onroute": "A caminho",
  "order.status.completed": "Concluído",
  "order.status.cancelled": "Cancelado",
  order_delivered: g,
  order_preparation: h,
  order_deliver: v,
  dinein: f,
  takeaway: L,
  loadMore: k,
  "userOrders.heading": "Histórico de pedidos",
  "userProfile.emptyTagsText": "Você ainda não tem tags! Clique aqui para adicionar",
  "gender.male": "Homem",
  "gender.female": "Mulheres",
  "gender.other": "Outro",
  "gender.na": "N/A",
  "userProfile.editInfoHeading": "Edite suas informações",
  save: b,
  name: y,
  surname: P,
  email: C,
  birthday: T,
  tags: A,
  gender: O,
  language: x,
  postCode: S,
  "userProfile.navigation.profile": "Perfil",
  "navigation.back": "Voltar",
  "shopLanding.address.error.unknown": "Ocorreu um erro. Tente novamente mais tarde",
  "shopLanding.address.error.locationTemporarilyUnavailable": "Desculpe, este serviço não está disponível no momento",
  "shopLanding.address.error.addressBothEmpty": "Por favor, preencha os campos de endereço e piso/porta",
  "shopLanding.address.error.addressEmpty": "Por favor, preencha o campo de endereço",
  "shopLanding.address.error.addressInfoEmpty": "Por favor, preencha o campo piso/porta",
  "shopLanding.singleRestaurant.eta.time": "{{time}} min",
  "shopLanding.singleRestaurant.eta": "Tempo estimado de preparo:",
  "shopLanding.redirection.title": "Parabéns!",
  "shopLanding.redirection": "Estamos redirecionando você para que possa fazer seu pedido",
  "shopLanding.noReach.title": "Nós não vamos para sua área",
  testDoNotTouch: "ccc",
  "userMenu.showProfile": "Mostrar perfil",
  "userMenu.logout": "Sair",
  "autocomplete.label": "Endereço",
  "autocomplete.placeholder": "Digite endereço incluindo o número",
  "autocomplete.geolocation": "Usar minha localização atual",
  "shopLanding.address.title": "De onde você faz o pedido?",
  "shopLanding.address.label": "Piso, porta...",
  "shopLanding.address.placeholder": "Especifique o endereço para entrega ou insira um espaço se não se aplicar",
  "shopLanding.address.error.suspended": "Desculpe, não podemos aceitar mais pedidos no momento. Tente novamente em 20 minutos. Muito obrigado!",
  "shopLanding.address.error.outOfRange": "Ops ... não estamos na sua área no momento. Você pode fazer um pedido para retirar no restaurante mais próximo!",
  "shopLanding.address.error.cannotDeliver": "Desculpe, no momento não podemos entregar no seu endereço. Recomendamos que você faça o pedido para coletar.",
  "shopLanding.address.error.invalidAddress": "Desculpe, o endereço é inválido. Verifique-o e insira-o novamente.",
  "shopLanding.address.error.missingStreet": "Por favor, insira o número da rua",
  "shopLanding.address.error.orderThrough": "Ou peça pelo:",
  "shopLanding.selector.title": "Levante a sua encomenda em: ",
  "shopLanding.selector.laterBtn": "Pedir mais tarde",
  "shopLanding.selector.nowBtn": "Peça agora",
  "shopLanding.selector.doOrder": "Fazer um pedido",
  "shopLanding.datetime.title": "Escolha um horário:",
  "shopLanding.datetime.dayPlaceholder": "Selecione um dia..",
  "shopLanding.datetime.hourPlaceholder": "Selecione um horário..",
  "shopLanding.datetime.cancelBtn": "Cancelar",
  "shopLanding.datetime.programBtn": "Programa",
  "shopLanding.singleRestaurant.title": "O local que irá atendê-lo:",
  delivery: V,
  pickup: w,
  unknown: E,
  phone: D,
  today: M,
  tomorrow: R,
  day: "Dia",
  hour: z,
  call: F,
  guest: N,
  loginText: q,
  uber: I,
  glovo: B,
  deliveroo: G,
  justeat: U,
  "phoneVerification.title": "Verifica o teu número de telefone",
  "phoneVerification.subtitle": "Vais receber o código por SMS no número {{phoneNumber}}",
  "phoneVerification.countdown": "Se não chegar, podes solicitar outro código em {{time}}",
  "phoneVerification.resend": "Solicitar outro código",
  "phoneVerification.back": "Voltar",
  "phoneVerification.continue": "Continuar",
  "phoneVerification.error": "Código inválido",
  "phoneVerification.error.invalidCode": "O código introduzido não é válido. Tenta novamente.",
  "phoneVerification.error.expired": "O código expirou. Por favor, solicita um novo.",
  "phoneVerification.error.alreadyUsed": "Este código já foi utilizado. Por favor, solicita um novo.",
  "phoneVerification.error.attemptsExceeded": "Demasiadas tentativas incorretas. Por favor, solicita um novo código.",
  "phoneVerification.error.generic": "Algo correu mal. Por favor, tenta novamente.",
  "phoneInputForm.error.otpRequestCooldown": "Por favor, aguarda antes de solicitar um novo código.",
  "phoneInputForm.error.otpRateLimit": "Demasiadas solicitações. Por favor, tenta novamente mais tarde.",
  "phoneInputForm.error.smsProviderError": "Não conseguimos enviar o SMS. Por favor, tenta novamente.",
  "phoneInputForm.title": "Introduz o teu número de telefone",
  "phoneInputForm.phoneLabel": "Telefone",
  "phoneInputForm.back": "Voltar",
  "phoneInputForm.continue": "Continuar",
  "duplicatePhoneError.title": "Já existe um utilizador com este número associado",
  "duplicatePhoneError.subtitle": "O número de telefone da tua conta já está registado por outro utilizador na plataforma. Inicia sessão com o email associado.",
  "duplicatePhoneError.back": "Voltar"
};
export {
  T as birthday,
  F as call,
  n as cashback,
  W as day,
  j as default,
  a as defaultFeeName,
  G as deliveroo,
  V as delivery,
  o as deliveryFee,
  f as dinein,
  l as discount,
  C as email,
  O as gender,
  B as glovo,
  N as guest,
  z as hour,
  U as justeat,
  x as language,
  k as loadMore,
  q as loginText,
  d as loyaltyCard,
  y as name,
  v as order_deliver,
  g as order_delivered,
  h as order_preparation,
  i as payLink,
  r as paymentMethods,
  D as phone,
  w as pickup,
  s as points,
  S as postCode,
  b as save,
  e as stampCards,
  u as subtotal,
  P as surname,
  A as tags,
  L as takeaway,
  H as testDoNotTouch,
  t as tier,
  m as tip,
  M as today,
  R as tomorrow,
  p as total,
  I as uber,
  E as unknown,
  c as vouchers
};
//# sourceMappingURL=translation.json.js.map
